/**
 * @enum {string}
 */
export const TreeSelectMode = {
  NONE: 'none',
  SINGLE: 'single',
  BULK: 'bulk',
};

/**
 * The mode to use for interacting with node actions. Either menu or buttons.
 * @enum {string}
 */
export const TreeActionsMode = {
  BUTTON: 'button',
  MENU: 'menu',
};
